var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"case-cover",class:'case-cover-' + _vm.size},[(_vm.image && !_vm.failed)?_c('img',{attrs:{"src":_vm.value,"alt":_vm.alt},on:{"error":function($event){_vm.failed = true}}}):_c('span',{staticClass:"case-cover-fallback",attrs:{"role":"img","aria-label":_vm.alt}},[_vm._v(_vm._s(_vm.fallback))])])
}
var staticRenderFns = []

export { render, staticRenderFns }